import { Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const Container = styled.div`
  padding: 0 4px;
  height: 20px;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.isAdmin ? theme.SECONDARY : '#fff')};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

const LiveBadge = ({ progress, gameStatus, isAdmin, sport }) => {
  const { t } = useTranslation();
  const [text, setText] = useState('');

  useEffect(() => {
    updateText();
  }, [progress, gameStatus]);

  function updateText() {
    let updatedText = '';

    switch (sport) {
      case 'soccer':
        updatedText = gameStatus === 'HT' ? gameStatus : `${progress}’`;
        break;
      default:
        updatedText = gameStatus;
        break;
    }

    setText(updatedText);
  }

  return (
    <Container isAdmin={isAdmin}>
      <Text bold size="12px" col={!isAdmin ? '#000' : '#fff'}>
        {t('common.live').toUpperCase()}
      </Text>

      {progress && (
        <Text marg="0 0 0 4px" bold numberOfLines={1} size="12px" col={!isAdmin ? '#000' : '#fff'}>
          {text}
        </Text>
      )}
    </Container>
  );
};

export default LiveBadge;
